import {handleEmailSending} from "../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const LbInfoContactEmail = () => {

    const name = fromCharCode(105, 110, 102, 111);
    const domain = fromCharCode(108, 98, 46, 108, 116);

    return (
        <>
            <a className="contact-by-email" href='#' onClick={(e) => handleEmailSending(e, name, domain)}>
                {`${fromCharCode(105, 110, 102, 111, 64, 108, 98, 46, 108, 116)}`}
            </a>
        </>
    )
}

export default LbInfoContactEmail;
